import SourceUtil from '@/utils/SourceUtil'

export default {
  uid2timeoutId: new Map(),
  /**
   * 函数防抖,当持续触发事件时，一定时间间隔内没有再触发事件，
   * 事件处理函数才会执行一次，若在设定的时间间隔内再次触发事件，则重新计时
   ** 主要应用场景:元素resize、input输入验证、实时搜索联想等
   * @param {Number} id 定时器ID
   * @param {Number} delay 延时时长,单位毫秒
   * @param {Function} func 回调函数
   */
  debounce(id, delay, func) {
    const uid = id.toString()
    if (this.uid2timeoutId.has(uid)) {
      const timeout = this.uid2timeoutId.get(uid)
      if (timeout) {
        clearTimeout(timeout)
      }
    }
    this.uid2timeoutId.set(uid, setTimeout(func, delay))
  },
  /**
   * 不传ID的简易防抖函数(函数内部按源码位置自动生成ID)
   * 不应使用nanoid(几乎不可能重复,将导致uid2timeoutId内存放的键值对永远无法释放)
   * @param {Number} delay 延时时长,单位毫秒
   * @param {Function} func 回调函数
   */
  debounceSimple(delay, func) {
    const uid = SourceUtil.getFileLineUuid()
    console.log('line uuid:', uid)
    this.debounce(uid, delay, func)
  },
  /**
   * 节流函数,按设定的时间间隔执行一次函数
   ** 主要应用场景:scroll、touchmove、mousemove等
   * @param {Function} fn 延时调用函数
   * @param {Number} delay 节流间隔,单位毫秒
   */
  throt(fn, delay = 100) {
    let pre = 0
    return function (...args) {
      const now = new Date().getTime()
      if (now - pre < delay) {
        return
      }
      pre = now
      return fn.apply(this, args)
    }
  },
  /**
   * @param {Function} fn 延时调用函数
   * @param {Number} delay 节流间隔
   * @param {Number} atleast 至少多长时间触发一次
   * @returns {Function} 延迟执行的方法
   */
  throtV2(fn, delay = 100, atleast) {
    let timer = null
    let previous = null
    return function () {
      let now = +new Date()
      if (!previous) previous = now
      if (atleast && now - previous > atleast) {
        fn()
        previous = now
        clearTimeout(timer)
      } else {
        clearTimeout(timer)
        timer = setTimeout(function () {
          fn()
          previous = null
        }, delay)
      }
    }
  }
}
